import React from 'react';
import { Link } from 'react-router-dom';

import { Typography, Grid, Divider } from '@mui/material';

import { trackEventMatomoElementId } from 'js/library/utils/helpers';

import { downloadImage } from 'js/library/services/StorageManager.js';
import placeholder from 'styles/assets/placeholder/placeholder.gif';

export const Establishment = ({ data }) => {
  const [downloadedImage, setDownloadedImage] = React.useState(null);
  const distance = data?.distance;
  const id = data.id;

  const verifyDistance = () => {
    if (distance !== null && typeof distance === 'number') {
      if (distance < 1) {
        return distance.toFixed(2) * 1000 + 'm';
      } else {
        return distance?.toFixed(2) + 'km';
      }
    } else {
      return null;
    }
  };

  function downloadImageOnLoad() {
    if (data.fotoThumb !== undefined && downloadedImage === null) {
      downloadImage('estabelecimento', data.fotoThumb)
        .then((downloaded) => {
          setDownloadedImage(downloaded);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  return (
    <div>
      <Grid container spacing={3} style={{ width: '100%' }}>
        <Grid size={{ xs: 12, md: 5, lg: 5 }}>
          <Link
            onClick={() => trackEventMatomoElementId('ListaDePromocao', 'tocar', 'card', id)}
            to={{
              pathname: '/estabelecimento/',
              search: '?id=' + id,
              state: data,
            }}
            style={{ textDecoration: 'none' }}
          >
            <img
              width="100%"
              alt="thumbnail estabelecimento"
              onLoad={() => downloadImageOnLoad()}
              className="img-radius"
              src={downloadedImage === null ? placeholder : downloadedImage}
            />
            <br />
          </Link>
        </Grid>

        <Grid size={{ xs: 12, md: 7, lg: 7 }}>
          <Link
            onClick={() => trackEventMatomoElementId('ListaDePromocao', 'tocar', 'card', id)}
            to={{
              pathname: '/estabelecimento/',
              search: '?id=' + id,
              state: data,
            }}
            style={{ textDecoration: 'none' }}
          >
            <Typography
              color="secondary"
              variant="subtitle1"
              style={{
                fontWeight: 'bold',
                lineHeight: '1.0',
                marginTop: '10px',
                marginBottom: '10px',
                maxWidth: '80%',
              }}
            >
              {data.nome}
            </Typography>
            <Typography
              className="limit-text"
              variant="body2"
              paragraph
              style={{ maxWidth: '80%' }}
            >
              {data.descricao}
            </Typography>

            <Typography variant="caption" color="secondary" style={{ maxWidth: '80%' }}>
              {data.endereco === 'Brasil' ? null : verifyDistance()}
            </Typography>
          </Link>
        </Grid>
      </Grid>
      <Divider style={{ margin: '20px 0px', float: 'right' }} width="80%" />
    </div>
  );
};

export default Establishment;

